<template>
  <layout :title="referral.full_name" v-if="referral">
    <v-row class="mb-4">
      <v-col cols="6">
        <div>
          Total Transaction Amount = <b>{{ formatPrice(referral.transaction_amount) }}</b>
        </div>
      </v-col>
    </v-row>
    <v-tabs class="tab-outlined" hide-slider v-model="tab">
      <v-tab class="text-none">Weekly</v-tab>
      <v-tab class="text-none">Daily</v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <v-tabs-items v-model="tab">
      <v-tab-item :transition="false">
        <referral-weekly-commissions :referral="referral" />
      </v-tab-item>
      <v-tab-item :transition="false">
        <referral-daily-commissions :referral="referral" />
      </v-tab-item>
    </v-tabs-items>
  </layout>
</template>

<script>
import Layout from "@/components/ui/Layout.vue";
import {doc, getDoc} from "firebase/firestore";
import {colReferrals} from "@/assets/utils/firebase.utils";
import ReferralWeeklyCommissions from "@/components/referrals/ReferralWeeklyCommissions.vue";
import ReferralDailyCommissions from "@/components/referrals/ReferralDailyCommissions.vue";

export default {
  components: {
    ReferralDailyCommissions,
    Layout,
    ReferralWeeklyCommissions,
  },
  data() {
    return {
      tab: 0,
      referral: null,
    };
  },
  computed: {
    referralId() {
      return this.$route.params.id;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.fetchReferral();
  },
  methods: {
    async fetchReferral() {
      try {
        let referral = (await getDoc(doc(colReferrals, this.referralId))).data();
        if (referral == null) {
          this.notifyError("Referral not found");
          this.$router.replace({ name: "referrals" });
          return;
        }
        this.referral = {
          ...referral,
          id: this.referralId,
          full_name: `${referral.first_name || ""} ${referral.last_name || ""}`
        };
      } catch (error) {
        this.handleError(error.message);
      }
    },
  },
};
</script>
